import React from 'react';

export function BlogRenderer({ content }) {
    if (!content) return null;

    return (
        <article className="max-w-5xl mx-auto px-4 space-y-8">
            {content.map((block, index) => {
                switch (block.type) {
                    case 'heading':
                        return block.level === 2 ? (
                            <h2 key={index} className="text-3xl font-bold italic mt-12 mb-2 text-black">{block.text}</h2>
                        ) : (
                            <h3 key={index} className="text-2xl font-bold mt-8 mb-4 text-black">{block.text}</h3>
                        );

                    case 'subheading':
                        return (
                            <h4 key={index} className="text-2xl font-bold italic text-black mt-0 mb-6">
                                {block.text}
                            </h4>
                        );

                    case 'paragraph':
                        return <p key={index} className="text-[15px] leading-7 text-justify text-gray-600 mb-6">{block.text}</p>;

                    case 'image':
                        return (
                            <figure key={index} className="my-8">
                                <img src={block.src} alt="" className="w-full rounded-xl shadow-lg" />
                                {block.caption && (
                                    <figcaption className="text-sm text-center mt-3 text-gray-500 italic">
                                        {block.caption}
                                    </figcaption>
                                )}
                            </figure>
                        );

                    case 'video':
                        return (
                            <div key={index} className="my-10">
                                <video
                                    src={block.src}
                                    poster={block.poster}
                                    controls
                                    className="w-full rounded-xl shadow-lg border border-gray-800"
                                />
                            </div>
                        );

                    default:
                        return null;
                }
            })}
        </article>
    );
}
